import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M443-164v-295L185-608v295l258 149Zm75 0 257-149v-296L518-459v295Zm-38-359 254-148-254-146-254 146 254 148ZM145-244q-19-11-29-30-10-18-10-39v-334q0-21 10-39 10-19 29-30l295-170q19-11 40-11t40 11l295 170q19 11 29 30 11 18 11 39v334q0 21-11 39-10 19-29 30L520-74q-19 11-40 11t-40-11L145-244Zm335-236Z"/>',
  f: '<path d="M440-74 145-244q-19-11-29-30-10-18-10-39v-334q0-21 10-39 10-19 29-30l295-170q19-11 40-11t40 11l295 170q19 11 29 30 11 18 11 39v334q0 21-11 39-10 19-29 30L520-74q-19 11-40 11t-40-11Zm3-385v294l37 22 38-22v-294l257-150v-38l-42-24-253 148-254-148-41 23v40l258 149Z"/>',
};

export default data;
